import { cn } from "~/lib/utils";

export const TeaserImage = ({
  image,
  alt,
  width,
  height,
  className,
  square = false,
}: {
  image: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  square?: boolean;
}) => {
  return (
    <img
      src={image}
      alt={alt}
      width={width}
      height={height}
      style={{
        width: width ? `${width}px` : "auto",
        height: height ? `${height}px` : "auto",
      }}
      className={cn(
        square ? "aspect-square" : "ratio-[620/350]",
        `w-full shadow-md rounded-md object-cover ${className}`
      )}
    />
  );
};
